export default "/images/finish_setup.webp"